var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.11.186a.5.5 0 0 1 .78.628l-14.5 18a.5.5 0 0 1-.744.04l-5-5a.5.5 0 0 1 .708-.708l4.606 4.607L23.11.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.786 12.606a.5.5 0 1 1 .974-.224c.159.692.24 1.4.24 2.118 0 5.246-4.254 9.5-9.5 9.5A9.498 9.498 0 0 1 0 14.5C0 9.252 4.252 5 9.5 5c1.485 0 2.92.34 4.223.988a.5.5 0 1 1-.446.896A8.456 8.456 0 0 0 9.5 6 8.498 8.498 0 0 0 1 14.5a8.5 8.5 0 1 0 16.786-1.894Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-circle.2327de5c4816f3dde727f156a92690c4.svg";